import { IModalProps, Modal } from '@fluentui/react/lib/Modal';

export interface IPModalProps extends IModalProps {}

export const IPModal = (props: IPModalProps) => {
  return <Modal {...props} />;
};
